null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.29/library-aux/src/main/scala/scala/runtime/Statics.scala